export function PersonaImportance() {
  return <div className="fs-20 vhc mt-100">Work in progress!</div>;
}
